import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, LoadingController, Events } from 'ionic-angular';
import { IlsProvider } from '../../providers/ils/ils';
import moment from 'moment';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { AppState } from '../../config/state';
/**
 * Generated class for the CoPatronFeesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-patron-fees',
  templateUrl: 'co-patron-fees.html'
})
export class CoPatronFeesPage {
  screen: string = 'payment';
  patron: any;
  finesList: any = [];
  cardInfoIsEntered: any = { cardNum: true, cvvNum: true, expDate: true, firstName: true, lastName: true };
  cardInfoObject: any = {};
  minimumDateForCard: string = moment().format('YYYY-MM-DD');
  emptyInputFieldStatus: boolean = false;
  paymentAmount: number;
  // sharedScreen: boolean = false;
  sendEmail: boolean = false;
  @ViewChild('firstNameCardInput') firstNameCardInput: ElementRef;
  @ViewChild('lastNameCardInput') lastNameCardInput: ElementRef;
  @ViewChild('cardNumberInput') cardNumberInput: ElementRef;
  @ViewChild('expirationDateInput') expirationDateInput: ElementRef;
  @ViewChild('cvvInput') cvvInput: ElementRef;
  constructor(public navCtrl: NavController, public navParams: NavParams, private ilsProvider: IlsProvider, private viewCtrl : ViewController, private toast : ToastAlertsProvider, public loading: LoadingController, private events : Events, private timeout : TimeoutFunctionsProvider, private state: AppState, private sounds : SoundsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.patron = this.navParams.data.patron;
    this.finesList = this.navParams.data.fines;
    // this.addBookInfo();
    this.paymentAmount = this.navParams.data.total;
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  addBookInfo() {
    let loader = this.loading.create({
      content: 'Getting book details...',
    });
    loader.present();
    if (this.patron.fines.length === 0) {
      loader.dismiss().catch(err=>{});
      return;
    }
    this.patron.fines.forEach((book, index) => {
      this.ilsProvider.getBibDetailsFromId(book.bib.id).then(res => {
		if(!res)return;
        if (res.upcs.length > 0) {
          book.isbnObj = { number: res.upcs[0], type: 'upc' };
        } else if (res.isbns.length > 0) {
          book.isbnObj = { number: res.isbns[0], type: 'isbn' };
        }
        book.bib = res;
        this.finesList.push(book);
      });
      if (index >= this.patron.fines.length - 1) loader.dismiss().catch(err=>{});
    });
  }

  validateCreditInfo() {
    let output = [];
    for (var key in this.cardInfoObject) {
      switch (key) {
        case ('cvvNum'):
          if (this.cardInfoObject.cvvNum.length < 3 || this.cardInfoObject.cvvNum.length > 4) {
            output.push(key);
            break;
          }
      }
    }

    output.forEach(input => {
      this.cardInfoIsEntered[input] = false;
    })

    return output.length <= 0;
  }

  async getCreditInput() {
    this.cardNumberInput.nativeElement.value ? this.cardInfoObject.cardNum = this.cardNumberInput.nativeElement.value : this.cardInfoObject.cardNum = null;

    this.cvvInput.nativeElement.value ? this.cardInfoObject.cvvNum = this.cvvInput.nativeElement.value : this.cardInfoObject.cvvNum = null;

    this.expirationDateInput.nativeElement.value ? this.cardInfoObject.expDate = this.expirationDateInput.nativeElement.value : this.cardInfoObject.expDate = null;

    this.firstNameCardInput.nativeElement.value ? this.cardInfoObject.firstName = this.firstNameCardInput.nativeElement.value : this.cardInfoObject.firstName = null;

    this.lastNameCardInput.nativeElement.value ? this.cardInfoObject.lastName = this.lastNameCardInput.nativeElement.value : this.cardInfoObject.lastName = null;
    this.cardInfoIsEntered = { cardNum: true, cvvNum: true, expDate: true, firstName: true, lastName: true };

    let empty = [];
    for (var key in this.cardInfoObject) {
      if (this.cardInfoObject[key] === null) {
        empty.push(key);
      };
    };
    empty.forEach(input => {
      this.cardInfoIsEntered[input] = false;
    });

    if (empty.length <= 0) {
      return this.validateCreditInfo();
    } else {
      return false;
    };
  }

  async submitPayment(){
    await this.getCreditInput().then(res => {
      if (res) {
        let msg;
        this.sendEmail? msg = 'Thank you for your payment, your receipt has been sent' : msg = 'Thank you for your payment';
        this.emptyInputFieldStatus = false;
        this.toast.triggerToast(msg,'', 'success');
        this.close(true);
      } else {
        this.emptyInputFieldStatus = true;
      };
    });
  }

  close(paid?){
    this.viewCtrl.dismiss(paid).catch(err=>{});
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-patron-fees/co-patron-fees.ts